import { render, staticRenderFns } from "./goodsCategory.vue?vue&type=template&id=efd3d9b8&scoped=true"
import script from "./goodsCategory.vue?vue&type=script&lang=js"
export * from "./goodsCategory.vue?vue&type=script&lang=js"
import style0 from "./goodsCategory.vue?vue&type=style&index=0&id=efd3d9b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd3d9b8",
  null
  
)

export default component.exports